var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Production Provisions'}}),_c('production-provisions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }